<div class="page">
  <div class="container">
    <h1>Privacy Policy — {{ appName }}</h1>
    <p class="meta">
      <strong>Effective Date:</strong> {{ effectiveDate | date:'longDate' }}
    </p>

    <p>
      {{ appName }} (“we”, “us”, or “our”) respects your privacy. This Privacy Policy explains how we collect,
      use, store, and share your information when you use our website and services, including when you sign in using Facebook Login.
    </p>

    <p>
      By using {{ appName }}, you agree to the collection and use of information in accordance with this Privacy Policy.
    </p>

    <hr />

    <h2>1. Information We Collect</h2>
    <p>We may collect the following types of information when you use our service:</p>

    <h3>A) Information You Provide</h3>
    <ul>
      <li>Account information you provide directly (if applicable)</li>
      <li>Messages, prompts, or text you submit to our service (if applicable)</li>
    </ul>

    <h3>B) Information We Receive from Facebook Login</h3>
    <p>If you choose to log in using Facebook, we may receive the following:</p>
    <ul>
      <li>Facebook public profile information (name, profile picture, Facebook user ID)</li>
      <li>Email address (if available and you grant permission)</li>
    </ul>
    <p>
      We only request Facebook permissions needed for authentication:
      <code>public_profile</code> and optionally <code>email</code>.
    </p>

    <h3>C) Automatically Collected Information</h3>
    <ul>
      <li>Device and browser type</li>
      <li>Pages visited and actions taken</li>
      <li>IP address (for security and fraud prevention)</li>
      <li>Cookies or similar technologies used for login/session functionality</li>
    </ul>

    <h2>2. How We Use Your Information</h2>
    <ul>
      <li>Authenticate your account and allow login access</li>
      <li>Provide and improve our services</li>
      <li>Maintain platform security and prevent fraud</li>
      <li>Communicate with you regarding service updates or support requests</li>
      <li>Comply with legal obligations</li>
    </ul>

    <h2>3. Cookies and Tracking Technologies</h2>
    <p>
      We use cookies and similar technologies to keep you logged in, remember preferences,
      and improve site performance and security. You can disable cookies in your browser settings,
      but some features may not function properly.
    </p>

    <h2>4. How We Share Information</h2>
    <p>We do <strong>not</strong> sell your personal data.</p>
    <p>We may share your information only in these cases:</p>

    <h3>A) Service Providers</h3>
    <p>
      We may share limited information with trusted third-party services that help us operate the website
      (hosting, database, analytics, authentication, etc.). These providers are required to protect your information.
    </p>

    <h3>B) Legal Requirements</h3>
    <p>
      We may disclose information if required by law or if necessary to comply with legal process, protect our rights,
      prevent fraud, or misuse.
    </p>

    <h2>5. Data Retention</h2>
    <p>
      We keep your information only as long as necessary to provide the service, comply with legal obligations,
      resolve disputes, and enforce agreements.
    </p>

    <h2>6. Your Rights and Choices</h2>
    <p>
      Depending on your location, you may have rights to access, correct, or delete your data.
    </p>

    <h2>7. Facebook Data Use</h2>
    <p>
      {{ appName }} uses Facebook Login to authenticate users and complies with Meta Platform Terms and Developer Policies.
      You may disconnect {{ appName }} from your Facebook account at any time by removing access in Facebook Settings →
      Apps and Websites.
    </p>

    <h2>8. Security</h2>
    <p>
      We use reasonable security measures to protect your information. However, no system is 100% secure and we cannot guarantee absolute security.
    </p>

    <h2>9. Children’s Privacy</h2>
    <p>
      {{ appName }} is not intended for children under the age of 13. We do not knowingly collect personal data from children.
    </p>

    <h2>10. Changes to This Policy</h2>
    <p>
      We may update this Privacy Policy from time to time. Updates will be posted on this page with a revised effective date.
    </p>

    <h2>11. Contact Us</h2>
    <div class="contact-box">
      <p><strong>Email:</strong> {{ contactEmail }}</p>
      <p><strong>Website:</strong> <a [href]="websiteUrl" target="_blank" rel="noopener noreferrer">{{ websiteUrl }}</a></p>
    </div>
  </div>
</div>
